window.handleClickTracking = ($el) => {
  const event = $el.data('t-event') || 'gaEvent';
  const eventAction = $el.data('t-action-click') || '';
  const eventCategory = $el.data('t-category') || '';
  const eventLabel = $el.data('t-label') || '';

  window.dataLayer.push({
    event,
    eventAction,
    eventLabel,
    eventCategory,
    nonInteraction: false,
  });
};

$(document).ready(() => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  $('[data-t-action-click]').on('click', (evt) => {
    const $el = $(evt.target).closest('[data-t-action-click]');
    if (!$el.data('t-no-auto')) {
      window.handleClickTracking($el);
    }
  });
});
